<template>
  <AuthLayout>
    <h1 class="auth-title">
      {{ $t('authentication.serviceDeactivate') }}
    </h1>
    <div class="log-deactivate fal fa-times-circle"></div>
    <span class="auth-subtitle">{{ $t('authentication.infoCC') }}</span>
  </AuthLayout>
</template>

<script>
  import AuthLayout from '../components/AuthLayout.vue'

  export default {
    name: 'Deactivate',
    components: {AuthLayout},
  }
</script>

<style lang="scss" scoped>
  .log-deactivate {
    margin: 2rem auto;
    font-size: 72px;
    color: #D0021B;
  }
</style>
